var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobotServerError = function SvgRobotServerError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273,
    height: 225,
    viewBox: "0 0 273 225"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.499,
    cy: 216.929,
    fill: "#FFF",
    fillOpacity: 0.4,
    rx: 71.5,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.29 45.319)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m121.886 122.566 2.018 28.86-57.78 4.04-2.018-28.86zM77.64 142.232l-6.19.433.432 6.184 6.19-.433zm39.207-2.742-6.19.433.432 6.184 6.19-.432zm-39.928-7.565-6.19.433.432 6.184 6.19-.433zm39.207-2.742-6.19.433.432 6.184 6.19-.432z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 173.55 6.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 33.063h6.206V57.86H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.551 39.262h21.564v12.399H1.551zm142.733 0h26.892v12.399h-26.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M167.555 33.063h6.206V57.86h-6.206zM12.411 0h148.938v107.454H12.411z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.004,
    height: 16,
    x: 41.292,
    y: 33.321,
    fill: "#110737",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.017,
    height: 16,
    x: 113.365,
    y: 32.757,
    fill: "#110737",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M105.442 42.981h32v12h-32zm-72.173-.035h32v12h-32z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24.823,
    height: 6.199,
    x: 79.594,
    y: 161.714,
    fill: "#FFF",
    rx: 3.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.708 39.11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A7E",
    d: "M37.031 38.455C30.1 45.11 2.365 75.355.274 86.048c-2.09 10.694 8.159 17.894 17.28 11.608 9.123-6.286 25.944-38.281 31.712-48.308 5.768-10.026 5.092-8.886 12.224-9.628s15.412-5.38 18.144-11.689q2.731-6.308 0-14.237L69.157 27.316l-12.043-3.681-5.312-9.98L61.49.396q-6.672-1.8-14.959 4.566c-4.73 3.635-7.758 12.557-5.165 20.21 1.582 4.671 1.582 7.6-4.335 13.282z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.857,
    cy: 87.253,
    r: 7,
    fill: "#110737"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.276,
    cy: 41.616,
    r: 4.5,
    fill: "#110737"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 17.066,
    height: 17.048,
    x: 164.179,
    y: 111.045,
    fill: "#FFF",
    rx: 8.524
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1)rotate(29 -192.664 -71.318)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 90,
    x: 22.069,
    fill: "#FF4A7E",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE0041",
    d: "M28.262 48.347h1c6.075 0 11 4.924 11 11v51a6 6 0 0 1-6 6h-11a6 6 0 0 1-6-6v-51c0-6.076 4.924-11 11-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 19,
    y: 6,
    fill: "#FF4A7E",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A7E",
    d: "M9.151 7.883q5.167 2.034 8.669 1.356c3.501-.678 7.762-6.053 24.393-6.053 16.63 0 22.944 9.454 24.354 13.26s.442 7.449-4.804 1.14-19.89 3.33-23.612 5.622-15.352.213-20.331-2.705q-4.98-2.917-8.669.974z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 17.066,
    height: 17.048,
    x: 52.427,
    y: 157.455,
    fill: "#FFF",
    rx: 8.524
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F70C54",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M117.245 170.519q9.488 15.835 24.859 21.955 15.37 6.12 26.573 3.677"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4A7E",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M116.229 168.854q6.293 17.355 20.213 26.295t25.383 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F70C54",
    d: "M55.661 68.091q5.049-59.73 73.65-64.549c68.602-4.817 82.006 38.76 82.006 51.687q0 12.927-155.656 12.862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE0041",
    d: "M124.739 1.045 137.707 0l3.671 54.074-12.968 1.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F70C54",
    d: "M83.04 71.823q21.252 11.613 54.92 9.86 33.67-1.754 55.001-21.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE0041",
    d: "m75.338 51.503 115.717-8.091a4 4 0 0 1 4.27 3.71l1.116 15.962-123.698 8.65-1.116-15.961a4 4 0 0 1 3.711-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F70C54",
    d: "m56.832 54.631 152.437-10.34a4 4 0 0 1 4.26 3.703l1.296 17.974L54.406 76.85l-1.293-17.94a4 4 0 0 1 3.72-4.279z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#110737",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M92.064 115.106q17.811 23.493 55 19.39"
  }))));
};
export default SvgRobotServerError;